import * as d3 from 'd3';
var ChartScale = /** @class */ (function () {
    function ChartScale(ctrlr, config) {
        this.ctrlr = ctrlr;
        this.config = config;
        this.dataLength = 0;
    }
    ChartScale.prototype.set = function (data, minValue) {
        if (!this.config.type)
            return;
        var self = this;
        this.dataLength = data.length;
        switch (this.config.type) {
            case 'linear':
                this.scale = d3.scaleLinear()
                    .domain([
                    minValue || 0,
                    d3.max(data, function (v) { return (v ? v : 0); })
                ]);
                break;
            case 'time':
                this.scale = d3.scaleTime()
                    .domain([
                    d3.min(data, function (d) { return (new Date(d) ? new Date(d) : 0); }),
                    d3.max(data, function (d) { return (new Date(d) ? new Date(d) : 0); }),
                ]);
                break;
            case 'band':
                this.scale = d3.scaleBand()
                    .domain(data)
                    .paddingInner(self.ctrlr.config.paddingInner)
                    .paddingOuter(self.ctrlr.config.paddingOuter)
                    .align(.5);
                break;
            case 'bandTime':
                this.scale = d3.scaleBand()
                    .domain(data)
                    .paddingInner(.2)
                    .paddingOuter(.5)
                    .align(.5);
                break;
            case 'radius':
                this.scale = d3.scalePow()
                    .domain([
                    d3.min(data, function (v) { return (v ? v : 0); }),
                    d3.max(data, function (v) { return (v ? v : 0); })
                ]).nice();
                break;
            case 'normalised':
                this.scale = d3.scaleLinear();
                break;
        }
        return this.scale;
    };
    ChartScale.prototype.reset = function () {
        if (!this.config.type)
            return;
        if (this.scale.domain().length < 2) {
            // console.log(this.config + this.scale.domain())
        }
        switch (this.config.direction) {
            case 'horizontal':
                this.scale
                    .range([0, this.ctrlr.dimensions.width]);
                break;
            case 'horizontal-reverse':
                this.scale
                    .range([this.ctrlr.dimensions.width, 0]);
                break;
            case 'vertical-reverse':
                this.scale
                    .range([0, this.ctrlr.dimensions.height]);
                break;
            case 'vertical':
                this.scale
                    .range([this.ctrlr.dimensions.height, 0]);
                break;
            case 'radius':
                var langsteZijde = this.ctrlr.dimensions.width > this.ctrlr.dimensions.height ? this.ctrlr.dimensions.width : this.ctrlr.dimensions.height;
                this.scale
                    .range([this.ctrlr.config.extra.minRadius, (langsteZijde / this.dataLength) * this.ctrlr.config.extra.radiusFactor]);
                break;
            case 'opacity':
                this.scale
                    .range([0.2, 1]);
                break;
            case 'flow':
                this.scale
                    .range([70, -70]);
        }
        return this.scale;
    };
    ChartScale.prototype.fn = function (x) {
        for (var _i = 0, _a = this.scale.range(); _i < _a.length; _i++) {
            var p = _a[_i];
            if (isNaN(p) || p == undefined) {
                // console.log(this.config.slug)
                // console.log(this.scale.range())
                throw new RangeError();
            }
        }
        var r = this.scale(x);
        if (isNaN(r)) {
            // console.log(this.config.slug + " : " + this.config.type)
            // console.log(x) 
            // console.log(this.scale.domain())
            // console.log(this.scale.range())
        }
        else {
            return r;
        }
    };
    ChartScale.prototype.domain = function () {
        return this.scale.domain();
    };
    ChartScale.prototype.range = function () {
        return this.scale.range();
    };
    ChartScale.prototype.bandwidth = function () {
        return this.scale.bandwidth();
    };
    return ChartScale;
}());
export { ChartScale };
